<template>
  <b-container>
    <h1 v-translate>New Service Quote</h1>
    <quote-services-create />
  </b-container>
</template>

<script>
import QuoteServicesCreate from '@/components/QuoteServicesCreate'
export default {
  components: {
    QuoteServicesCreate
  }
}
</script>
